import { useState, useEffect } from 'react';
import { NotificationBar } from '@nextgen-web-framework/all';
import { StorageService } from '@nextgen-web-framework/core';
import { LocalStorageKeys } from '../../utils/common';
import type { NotificationProps } from './types/propsTypes';
import styles from './Notification.module.scss';
const Notification = (props: NotificationProps) => {
  const [isView, setIsView] = useState(false);

  useEffect(() => {
    const getViewState = () => {
      if (!props._version) {
        return false;
      }
      const storedVersion = Number(
        StorageService.getLocalStorage().retrieve(LocalStorageKeys.NOTIFICATION_VERSION_NUMBER),
      );
      return !(storedVersion === props._version);
    };
    setIsView(getViewState());
  }, [props._version]);

  return (
    <>
      {isView && (
        <div
          className={styles['notificationbar-container']}
          id="notificationbar-id"
          data-testid={'notification-test-id'}
        >
          <NotificationBar
            message={props.message}
            iconClickHandler={() => {
              setIsView(false);
              StorageService.getLocalStorage().store(LocalStorageKeys.NOTIFICATION_VERSION_NUMBER, props._version);
            }}
          />
        </div>
      )}
    </>
  );
};
export default Notification;
